import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPageSeo } from './applyPageSeo';
import { getPageSeo, normalizePathname } from './seoConfig';

/** Updates document title, meta, canonical, Open Graph, Twitter tags, and JSON-LD from the current route. */
export function SeoHead(): null {
  const { pathname } = useLocation();

  useEffect(() => {
    const path = normalizePathname(pathname);
    applyPageSeo(path, getPageSeo(path));
  }, [pathname]);

  return null;
}
